"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.min = void 0;
var min = function (array) {
    return array.length === 0
        ? undefined
        : array.reduce(function (mn, curr) { return (curr < mn ? curr : mn); }, array[0]);
};
exports.min = min;
